var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-group row" }, [
    _c(
      "div",
      { staticClass: "col-md-10", class: { "whirl no-overlay": _vm.loading } },
      [
        _vm._l(_vm.files, function(item, index) {
          return !_vm.loading
            ? _c("div", { key: index, staticClass: "row" }, [
                _c("div", { staticClass: "col-3" }, [
                  _c("img", { attrs: { src: item.fullPath, width: "300" } })
                ])
              ])
            : _vm._e()
        }),
        _c("b-form-file", {
          attrs: { state: Boolean(_vm.file), placeholder: "Choose a file..." },
          on: { change: _vm.upload },
          model: {
            value: _vm.file,
            callback: function($$v) {
              _vm.file = $$v
            },
            expression: "file"
          }
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }